import React from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import connectPropTypes from '../utilities/connectPropTypes'
import debounce from '../utilities/debounce'
import searchTypes, { allSearchTypes } from '../enums/searchTypes'
import maybe from '../utilities/maybe'
import styles from './SearchBox.icss'

class SearchBox extends React.Component {
	constructor(props) {
		super(props)

		this.searchQueriesByType = {
			[searchTypes.ITEM.type]: props.searchItem,
			[searchTypes.KIT.type]: props.searchKit,
			[searchTypes.USER.type]: props.searchUser,
			[searchTypes.EVERYTHING.type]: (...args) => {
				props.searchItem(...args)
				props.searchKit(...args)
				props.searchUser(...args)
			}
		}

		this.state = {
			searchQuery: props.searchQueryOverride || props.searchQuery || '',
			prevQuery: undefined,
			prevSearchType: undefined
		}

		this.searchHandler = debounce((searchQuery) => {
			this.handleSearch(searchQuery)
		}, 200)

		this.handleUpdateInput = (searchQuery) => {
			this.searchHandler(searchQuery)
			this.setState({ searchQuery })
		}

		this.handleSearch = this.handleSearch.bind(this)
	}

	componentDidMount() {
		//  Load something in to start with
		//  TODO: Create an index of interesting stuff that is relevant to the user.
		//  NOTE: See the feed in functions on how to do that.
		if (this.props.searchOnMount) {
			this.searchHandler(this.state.searchQuery || '')
		}
	}

	handleSearch(query) {
		const searchType = this.props.searchTypeOverride || this.props.searchType
		const searchQuery = this.searchQueriesByType[searchType]
		const shallSearch = this.state.prevSearchType !== searchType || this.state.prevQuery !== query

		if (shallSearch) {
			if (searchQuery) {
				const facets = this.props.facetsByType[searchType] || {}
				searchQuery({ query, facets })
				this.props.onSearch({ searchType, query, facets })
				this.setState({ prevSearchType: searchType, prevQuery: query })
			} else {
				console.error('INVALID SEARCH TYPE', searchType)
			}
		}
	}

	render() {
		return (
			<div className={styles.searchSurround}>
				<TextField
					onChange={event => this.handleUpdateInput(event.target.value)}
					value={this.state.searchQuery}
					fullWidth
					autoFocus={this.props.autoFocus}
					onBlur={this.props.onBlur}
					placeholder={this.props.hintText}
					classes={{ root: styles.searchBoxField }}
					inputProps={{ className: styles.searchInput, ...maybe({ onFocus(e) { e.target.select(); e.target.setSelectionRange(0, 99999) }, onMouseUp: () => false }, this.props.autoFocus) }}
					InputProps={{ classes: { root: styles.searchInput } }} // eslint-disable-line react/jsx-no-duplicate-props
				/>
			</div>
		)
	}
}

SearchBox.propTypes = {
	hintText: PropTypes.string.isRequired,
	searchOnMount: PropTypes.bool,
	searchQuery: PropTypes.string,
	searchQueryOverride: PropTypes.string,
	searchType: PropTypes.oneOf(allSearchTypes),
	searchTypeOverride: PropTypes.oneOf(allSearchTypes, undefined),
	searchItem: PropTypes.func.isRequired,
	searchKit: PropTypes.func.isRequired,
	searchUser: PropTypes.func.isRequired,
	autoFocus: PropTypes.bool,
	onBlur: PropTypes.func,
	onSearch: PropTypes.func,
	facetsByType: PropTypes.objectOf(PropTypes.object) // eslint-disable-line react/forbid-prop-types
}

SearchBox.defaultProps = {
	searchOnMount: true,
	searchQuery: '',
	searchQueryOverride: undefined,
	searchType: searchTypes.EVERYTHING.type,
	searchTypeOverride: undefined,
	autoFocus: false,
	onBlur: () => { },
	onSearch: () => { },
	facetsByType: {}
}

export const testing = {
	SearchBox
}

export default connectPropTypes(SearchBox)



// WEBPACK FOOTER //
// ./src/components/SearchBox.jsx